import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=3d910836&scoped=true&"
import script from "./columns.vue?vue&type=script&lang=js&"
export * from "./columns.vue?vue&type=script&lang=js&"
import style0 from "../less/columns.less?vue&type=style&index=0&id=3d910836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d910836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d910836')) {
      api.createRecord('3d910836', component.options)
    } else {
      api.reload('3d910836', component.options)
    }
    module.hot.accept("./columns.vue?vue&type=template&id=3d910836&scoped=true&", function () {
      api.rerender('3d910836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/columns.vue"
export default component.exports